import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import { AnalyticsBigText, AnalyticsNormalText, AnalyticsBigTextWithNormalText } from 'pages/analytics/components/AnalyticsTextComponents';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import AnalyticsCard from 'pages/analytics/components/AnalyticsCard';
import { getIndividualAttendenceAnalytic } from 'actions/analytics/eventsAnalyticsAction';

class TotallShowedUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshState: new Date().getTime(),
        };
    }

    componentDidMount() {
        this.props.load().then(res => {
            let totalPplRegistered = res.data[0][0].sgbcRegisteredIndividual + res.data[1][0].nonsgbcRegisteredIndividual;

            let totalPplAttended = res.data[2][0].totalPeopleAttended;
            let attendenceText = res.data[2][0].totalPeopleAttended + '/' + totalPplRegistered;
            res.data[4] = attendenceText;
            this.setState({
                data: res.data,
            });
        });
    }

    componentDidUpdate() {
        if (this.state.refreshState != this.props.events.refresh) {
            this.props.load().then(res => {
                let totalPplRegistered = res.data[0][0].sgbcRegisteredIndividual + res.data[1][0].nonsgbcRegisteredIndividual;

                let totalPplAttended = res.data[2][0].totalPeopleAttended;
                let attendenceText = res.data[2][0].totalPeopleAttended + '/' + totalPplRegistered;
                res.data[4] = attendenceText;
                this.setState({
                    data: res.data,
                    refreshState: this.props.events.refresh,
                });
            });
        }
    }

    render() {
        const xs = {
            bigxs: 4,
            normalxs: 8,
        };
        return (
            <AnalyticsCard title={`Attendance: By Individual`} height={100}>
                {this.state.data == null ? (
                    <LoadingSpinner />
                ) : (
                    <React.Fragment>
                        <AnalyticsBigTextWithNormalText
                            normalText={`Members Registered `}
                            normalTextColor={`unset`}
                            bigText={this.state.data[0][0].sgbcRegisteredIndividual}
                            bigTextColor={`#f8ac59`}
                            {...xs}
                        />
                        <AnalyticsBigTextWithNormalText
                            normalText={`Non-Members Registered`}
                            normalTextColor={`unset`}
                            bigText={this.state.data[1][0].nonsgbcRegisteredIndividual}
                            bigTextColor={`#f8ac59`}
                            {...xs}
                        />
                        <AnalyticsBigTextWithNormalText
                            normalText={`Attended`}
                            normalTextColor={`unset`}
                            bigText={this.state.data[4]}
                            bigTextColor={`#78BE20`}
                            {...xs}
                        />
                    </React.Fragment>
                )}
            </AnalyticsCard>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
        events: state.eventsAnalyticsReducer,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        load: () => {
            return dispatch(getIndividualAttendenceAnalytic()); //getIndiviudalAttedenceAnalytic
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(TotallShowedUp));
